import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { cn } from '@/lib/utils'

interface LogoProps {
    tone?: 'light' | 'dark'
    size?: 'md' | 'lg'
    showWordmark?: boolean
    className?: string
}

export const Logo: FC<LogoProps> = ({
    tone = 'light',
    size = 'md',
    showWordmark = true,
    className
}): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-3', className)}>
            <span
                className={cn(
                    'relative shrink-0 overflow-hidden rounded-xl bg-brand-slate shadow-[0_10px_24px_-12px_rgba(31,43,48,0.9)] ring-1 ring-brand-gold/35',
                    size === 'lg' ? 'size-14' : 'size-11'
                )}
            >
                <Image
                    src='/images/brand/loveth-tasty-logo.jpg'
                    alt=''
                    fill
                    sizes={size === 'lg' ? '56px' : '44px'}
                    className='scale-110 object-cover object-[50%_18%]'
                />
            </span>

            {showWordmark && (
                <span className='flex flex-col leading-none'>
                    <span
                        className={cn(
                            'font-heading font-semibold tracking-tight',
                            size === 'lg' ? 'text-[1.75rem]' : 'text-[1.45rem]',
                            tone === 'light' ? 'text-brand-charcoal' : 'text-brand-white'
                        )}
                    >
                        Loveth Tasty
                    </span>

                    <span
                        className={cn(
                            'mt-1 text-[0.6rem] font-semibold uppercase tracking-[0.42em]',
                            tone === 'light' ? 'text-brand-burnt' : 'text-brand-gold'
                        )}
                    >
                        Global
                    </span>
                </span>
            )}
        </span>
    )
}
